import appointments from './Data';

const fakeData = [...appointments];

export default fakeData;